import styled from 'styled-components';

import { SYNMATCH_COLORS, SYNMATCH_RADII } from 'theme';

export type StatePanelTone = 'neutral' | 'error' | 'warning' | 'info';

interface ToneStyle {
  border: string;
  background: string;
  foreground: string;
}

const TONE_STYLES: Record<StatePanelTone, ToneStyle> = {
  neutral: {
    border: SYNMATCH_COLORS.border.default,
    background: SYNMATCH_COLORS.surface.app,
    foreground: SYNMATCH_COLORS.text.muted,
  },
  error: {
    border: SYNMATCH_COLORS.status.error.bg,
    background: SYNMATCH_COLORS.status.error.bg,
    foreground: SYNMATCH_COLORS.status.error.fg,
  },
  warning: {
    border: SYNMATCH_COLORS.status.warn.bg,
    background: SYNMATCH_COLORS.status.warn.bg,
    foreground: SYNMATCH_COLORS.status.warn.fg,
  },
  info: {
    border: SYNMATCH_COLORS.status.info.bg,
    background: SYNMATCH_COLORS.status.info.bg,
    foreground: SYNMATCH_COLORS.status.info.fg,
  },
};

export const StatePanelRoot = styled.div`
  max-width: 34rem;
  margin-inline: auto;
  text-align: center;
  padding-block: clamp(2.5rem, 7vw, 4.5rem);
`;

export const StatePanelMark = styled.span<{ $tone: StatePanelTone }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.6rem;
  height: 2.6rem;
  margin-bottom: 1.4rem;
  border-radius: ${SYNMATCH_RADII.pill};
  border: 0.0625rem solid ${({ $tone }) => TONE_STYLES[$tone].border};
  background: ${({ $tone }) => TONE_STYLES[$tone].background};
  color: ${({ $tone }) => TONE_STYLES[$tone].foreground};

  .MuiSvgIcon-root {
    font-size: 1.25rem;
  }
`;

export const StatePanelHeading = styled.h2`
  margin: 0 0 0.7rem;
  font-size: clamp(1.4rem, 3vw, 1.9rem);
  font-weight: 600;
  letter-spacing: -0.022em;
  line-height: 1.1;
  color: ${SYNMATCH_COLORS.primary};
  overflow-wrap: anywhere;

  &:focus {
    outline: none;
  }
`;

export const StatePanelMessage = styled.p`
  margin: 0 auto;
  max-width: 28rem;
  font-size: 1rem;
  line-height: 1.55;
  color: ${SYNMATCH_COLORS.text.muted};
`;

export const StatePanelActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.8rem;
  margin-top: 1.8rem;
`;
